import { useSelector } from "react-redux";
import { translate as getTranslate } from '@haldor/ui';
export var useTranslate = function useTranslate() {
  return getTranslate(useSelector(function (state) {
    return state.Languages.translations;
  }));
};